import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { withStyles, Grid } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { IconButton } from '../default'
import CardPaper from './CardPaper'
import { CreateNotificationModal } from '../modal'
import { acSetNofiticationsModal } from '../../class/actions'
import { DB_CONST } from '../../class/constants'

function CardNotification({
    classes, currentNofificationsModal
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const loadCreateNotification = () => {
        dispatch(acSetNofiticationsModal(DB_CONST.NOTIFICATION_MODALS.CREATE))
    }

    return (
        <div className={classes.form}>
            <CreateNotificationModal
                onClose={() => dispatch(acSetNofiticationsModal(null))}
                open={currentNofificationsModal === DB_CONST.NOTIFICATION_MODALS.CREATE} />

            <Grid container spacing={1}>

                <Grid item xs={3} className={classes.gridItem}>
                    <CardPaper style={{ width: '100%', height: '100%' }}>
                        <IconButton
                            className={classes.formField}
                            onClick={loadCreateNotification}
                            icon={Add}
                        >
                            {t('cards.notifications.btnCreate')}
                        </IconButton>
                    </CardPaper>
                </Grid>

            </Grid>
        </div>
    )
}

CardNotification.propTypes = {
    onSearch: PropTypes.func,
}

CardNotification.defaultProps = {
    onSearch: () => true
}

const styles = theme => ({
    header: {
        textAlign: 'center'
    },
    form: {
        display: 'flex',
        alignItems: 'center'
    },
    formField: {
        width: '100%',
        height: '100%'
    },
    gridItem: {
        display: 'flex',
        alignItems: 'flex-start'
    }
})

const mapStateToProps = ({ ReducerNotification }) => ({
    currentNofificationsModal: ReducerNotification.currentNofificationsModal
})

export default connect(mapStateToProps)(withStyles(styles)(CardNotification))